import { Link } from 'react-router-dom';

/**
 * The app mark: a 32px link to the root with the accessible name "Calis" and no wordmark beside
 * it (02-patterns §1.3), or — `decorative` — the same glyph as presentation, for the sign-in page
 * where the heading carries the name. Drawn from tokens so it holds in both themes.
 *
 * Why a chalice: "calis" is the Latin-derived word for a cup, and the owner asked for it. The
 * glyph is three strokes — bowl, stem, foot — so it stays legible at 32px against any bar.
 */
export function AppMark({ className, decorative = false }: { className?: string; decorative?: boolean }) {
  const glyph = (
    <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" focusable="false">
      <rect x="1" y="1" width="30" height="30" rx="8" className="app-mark__tile" />
      {/* Bowl: an open cup with a flat rim. */}
      <path d="M8.5 9.5h15M10 9.5v3a6 6 0 0 0 12 0v-3" className="app-mark__glyph" />
      {/* Stem and foot. */}
      <path d="M16 18.5v5.5M11 25.5h10" className="app-mark__glyph" />
    </svg>
  );
  // Why a plain span when decorative: the sign-in page's h1 already says "Calis" and the page is
  // the root, so a second link home would be a focus stop that goes nowhere. Hidden from assistive
  // technology, and no hit area because there is nothing to hit.
  if (decorative) return <span className={['app-mark', className].filter(Boolean).join(' ')} aria-hidden="true">{glyph}</span>;
  return (
    <Link to="/" className={['app-mark', 'hit-area', className].filter(Boolean).join(' ')} aria-label="Calis">
      {glyph}
    </Link>
  );
}
